import init from './init';

export default () => {
  document.addEventListener('shopify:section:load', function (e) {
    init(document.querySelector(`[data-section-id="${e.detail.sectionId}"]`));
  });
};
